{#if list.label}
    <h2 id="{id}{index+1}" class="prom-dropdown__listheader">{list.label}</h2>
{/if}

<ul
    on:keyup={(event) => dispatch('keyup', event)}
    aria-labelledby="{list.label ? id + (index+1) : null}"
    role="menu"
>

    {#each list.options as option}
    <ListItem
        {isSubmenu}
        {option}
        on:dropdownClose
        on:click
    />
    {/each}
</ul>

<script>
    import ListItem from './ListItem.svelte';
    import { guidV4 } from '@itslearning/atlas/generate/guid';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    /** @type {string} */
    export let id = guidV4();
    /** @type {number} */
    export let index = 0;
    /** @type {boolean} */
    export let isSubmenu = false;
    /** @type {object} */
    export let list = null;
</script>
